import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {

  imageUrlSource = new BehaviorSubject<string>('');
  currentImageUrl = this.imageUrlSource.asObservable();
  
  constructor(private readonly http: HttpClient) {
  // Initialize with stored image URL
  const storedImageUrl = localStorage.getItem('profile_image');
  if (storedImageUrl) {
    this.imageUrlSource.next(storedImageUrl);
  }
  }

  /**
   * Uploads a file to the server
   * @param formData The form data object containing the file to be uploaded
   * @returns An observable of the response from the server
   */
  public fileUpload(formData: FormData): Observable<any> {
    const endpoint = `${environment.API_BASE_URL}file/upload`;
    return this.http.post<any>(endpoint, formData);
  }

  /**
   * Updates the current image URL
   * @param url The new image URL
   * @remarks
   * This function updates the current image URL in the service and notifies all subscribers
   * of the change.
   */
  updateImageUrl(url: string) {
    if (url) {
      localStorage.setItem('profile_image', url);
      this.imageUrlSource.next(url);
    }
  }
}
